<template>
    <div class="row" ref="block_bank">
        <div class="col-md-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <i class="fa fa-bank"></i><span>{{ lang(title) }}</span>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-md-6 col-sm-6" ref="sub_block_bank_account">
                            <div class="panel-sub-heading headingSmall "><span
                                    class="markedBottom">{{ lang('bank_account') }}</span></div>
                            <np-input
                                    id="account_holder_name"
                                    :name="`${prefix}account_holder_name`"
                                    :is-full="true"
                                    ref="account_holder_name"
                                    :label="lang('account_holder_name')"
                                    v-model="bank.account_holder_name">
                            </np-input>
                            <div class="row compactInputFormat">
                                <div class="col-12 col-md-4">
                                    <label>{{lang('bank_sort_code') + '/' + lang('account_number')}}</label>
                                </div>
                                <div class="col-4 col-sm-4 col-md-3">
                                    <np-input
                                            id="bank_sort_code"
                                            :name="`${prefix}bank_sort_code`"
                                            ref="bank_sort_code"
                                            :label="lang('bank_sort_code')"
                                            v-model="bank.bank_sort_code"
                                            :rules="['numeric']"
                                            :no-wrapper="true">
                                    </np-input>
                                </div>
                                <div class="col-8 col-sm-8 col-md-5">
                                    <np-bank
                                            id="bank_account_number"
                                            :name="`${prefix}bank_account_number`"
                                            ref="bank_account_number"
                                            :label="lang('account_number')"
                                            :rules="['numeric']"
                                            :no-wrapper="true"
                                            :sort-code="bank.bank_sort_code"
                                            v-model="bank.bank_account_number">
                                    </np-bank>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <np-input
                                            id="dda_number"
                                            :name="`${prefix}dda_number`"
                                            ref="account_holder_name"
                                            :label="lang('dda_number')"
                                            v-model="bank.dda_number">
                                    </np-input>
                                    <np-input
                                            id="routing_number"
                                            :name="`${prefix}routing_number`"
                                            ref="routing_number"
                                            :label="lang('routing_number')"
                                            v-model="bank.routing_number">
                                    </np-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6" ref="sub_block_bank_address">
                            <div class="panel-sub-heading headingSmall "><span
                                    class="markedBottom">{{lang('bank_name_and_address')}}</span></div>
                            <div class="row">
                                <div class="col-md-12">
                                    <np-input
                                            id="bank_name"
                                            :name="`${prefix}bank_name`"
                                            ref="bank_name"
                                            :label="lang('bank_name')"
                                            v-model="bank.bank_name">
                                    </np-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <np-input
                                            id="zip_code"
                                            :name="`${prefix}zip_code`"
                                            :ref="`zip_code`"
                                            :label="lang('zip_code')"
                                            v-model="bank.zip_code"
                                    >
                                    </np-input>
                                    <np-input
                                            id="house_name"
                                            :name="`${prefix}house_name`"
                                            ref="house_name"
                                            :label="lang('house_name')"
                                            :no-wrapper="false"
                                            :required="false"
                                            v-model="bank.house_name">
                                    </np-input>
                                    <np-input
                                            id="house_number"
                                            :name="`${prefix}house_number`"
                                            ref="house_number"
                                            :label="lang('house_number')"
                                            v-model="bank.house_number">
                                    </np-input>
                                    <np-input
                                            id="street_line_1"
                                            :name="`${prefix}street_line_1`"
                                            ref="street_line_1"
                                            :label="lang('street_line_1')"
                                            v-model="bank.street_line_1">
                                    </np-input>
                                    <np-input
                                            id="bank_city"
                                            :name="`${prefix}bank_city`"
                                            ref="bank_city"
                                            :label="lang('city')"
                                            v-model="bank.bank_city">
                                    </np-input>
                                    <np-input
                                            id="county_code"
                                            :name="`${prefix}county_code`"
                                            ref="county_code"
                                            :label="lang('county')"
                                            v-model="bank.county_code">
                                    </np-input>
                                    <np-select2
                                            ref="country_code"
                                            id="country_code"
                                            :name="`${prefix}country_code`"
                                            :mode="`country`"
                                            :label="lang('country')"
                                            :parameters="params.COUNTRIES_PARAM"
                                            :no-wrapper="false"
                                            v-model="bank.country_code">
                                    </np-select2>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { NPInput, NPSelect2, NPBank } from 'netpify/components';
    export default {

        name: "np-bank-panel",
        components: { 'np-input': NPInput, 'np-select2': NPSelect2, 'np-bank': NPBank},
        description: "This component is used to display Bank Component on Merchant/Outlet Pages",
        data: function () {
            return {
            }
        },
        props: {
            bank: {
                type: Object,
                required: true
            },
            params: {},
            title: '',
            prefix: ''
        },
        computed: {
        },
        methods: {
            formatCountry: function(data) {
                let vm = this;
                if(!!data) {
                    return this.formatSelectType(vm.parameters, data, 'COUNTRIES_PARAM');
                } else {
                    return '-';
                }
            },
        }
    }
</script>
